import type { Workload } from "./types";

export type PresetId =
  | "poc"
  | "mvp"
  | "web_app"
  | "mobile_backend"
  | "internal_tool"
  | "api_light"
  | "chat_app"
  | "rag_search"
  | "high_traffic_ai";

export const WORKLOAD_PRESETS: Record<PresetId, Workload> = {
  poc: {
    usersDaily: 400,
    requestsPerUser: 10,
    enabledFeatures: ["storage"],
    avgPromptTokens: 0,
    avgCompletionTokens: 0,
    aiRequestShare: 0,
    storageKbPerUser: 24,
  },
  mvp: {
    usersDaily: 2_800,
    requestsPerUser: 30,
    enabledFeatures: ["storage", "chat", "ai"],
    avgPromptTokens: 120,
    avgCompletionTokens: 180,
    aiRequestShare: 0.14,
    storageKbPerUser: 40,
  },
  web_app: {
    usersDaily: 12_000,
    requestsPerUser: 38,
    enabledFeatures: ["storage", "search"],
    avgPromptTokens: 0,
    avgCompletionTokens: 0,
    aiRequestShare: 0,
    storageKbPerUser: 48,
  },
  mobile_backend: {
    usersDaily: 18_000,
    requestsPerUser: 70,
    enabledFeatures: ["storage", "files"],
    avgPromptTokens: 0,
    avgCompletionTokens: 0,
    aiRequestShare: 0,
    storageKbPerUser: 72,
  },
  internal_tool: {
    usersDaily: 650,
    requestsPerUser: 95,
    enabledFeatures: ["storage", "search"],
    avgPromptTokens: 0,
    avgCompletionTokens: 0,
    aiRequestShare: 0,
    storageKbPerUser: 56,
  },
  api_light: {
    usersDaily: 5_000,
    requestsPerUser: 24,
    enabledFeatures: ["storage"],
    avgPromptTokens: 0,
    avgCompletionTokens: 0,
    aiRequestShare: 0,
    storageKbPerUser: 32,
  },
  chat_app: {
    usersDaily: 10_000,
    requestsPerUser: 100,
    enabledFeatures: ["chat", "storage", "ai"],
    avgPromptTokens: 180,
    avgCompletionTokens: 320,
    aiRequestShare: 0.35,
    storageKbPerUser: 48,
  },
  rag_search: {
    usersDaily: 8_000,
    requestsPerUser: 60,
    enabledFeatures: ["chat", "storage", "search", "ai"],
    avgPromptTokens: 350,
    avgCompletionTokens: 550,
    aiRequestShare: 0.45,
    storageKbPerUser: 64,
  },
  high_traffic_ai: {
    usersDaily: 50_000,
    requestsPerUser: 120,
    enabledFeatures: ["chat", "storage", "search", "ai", "realtime"],
    avgPromptTokens: 220,
    avgCompletionTokens: 400,
    aiRequestShare: 0.4,
    storageKbPerUser: 96,
  },
};
